export default __webpack_public_path__ + "static/media/IMG_0052_1_11zon.db319c49.jpg";